import script from "./AvisosTab.vue?vue&type=script&setup=true&lang=js"
export * from "./AvisosTab.vue?vue&type=script&setup=true&lang=js"

import "./AvisosTab.vue?vue&type=style&index=0&id=486576ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-486576ce"]])

export default __exports__